import { useCallback } from 'react';
import { PromptGroup } from '@server/prompts';
import { usePromptGroups } from './usePromptGroups';

export const useCategoryActions = (categories: PromptGroup[]) => {
  const { loadPromptGroups, createPromptGroup, updatePromptGroup, removePromptGroup, pinGroup } =
    usePromptGroups();

  const handleCreateCategory = useCallback(
    async (name: string, iconName: string) => {
      return createPromptGroup({
        id: '',
        name,
        iconName,
        isPinned: false,
        description: '',
        accountId: '',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        prompts: [],
      });
    },
    [createPromptGroup],
  );

  const handleEditCategory = useCallback(
    async (categoryId: string, name: string, iconName: string) => {
      const category = categories.find((c) => c.id === categoryId);
      if (category) {
        return updatePromptGroup({ ...category, name, iconName });
      }
      return null;
    },
    [updatePromptGroup, categories],
  );

  const handleDeleteCategory = useCallback(
    async (categoryId: string) => {
      await removePromptGroup(categoryId);
    },
    [removePromptGroup],
  );

  const handlePinCategory = useCallback(
    async (categoryId: string) => {
      await pinGroup(categoryId, true);
    },
    [pinGroup],
  );

  const handleUnpinCategory = useCallback(
    async (categoryId: string) => {
      await pinGroup(categoryId, false);
    },
    [pinGroup],
  );

  return {
    fetchCategories: loadPromptGroups,
    handleCreateCategory,
    handleEditCategory,
    handleDeleteCategory,
    handlePinCategory,
    handleUnpinCategory,
  };
};
